import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class AnnotationtypeService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  getAnnotationtypesByVersion(version) {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("version", version);
      this.http
        .get<any>(this.env.managirUrl + "/assets/annotationtypes/", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.AnnotationtypeResponse.annotationtypes.types);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/annotationtype/annotationtype.service.ts